import React from "react";

import UserAutosuggestTextField from "../UserAutosuggestTextField";

const FormikUserAutosuggestTextField = ({ form, name, ...rest }) => {
  const value = form.values[name];
  const error = form.errors[name];
  const isTouched = form.touched[name];

  return (
    <UserAutosuggestTextField
      {...rest}
      name={name}
      value={value}
      error={isTouched && error !== undefined}
      helperText={isTouched && error !== undefined ? error : " "}
      onBlur={form.handleBlur}
      onChange={form.handleChange}
    />
  );
};

export default FormikUserAutosuggestTextField;
